import type { Config } from '@master/css'
const config: Config = {
    classes: {},
    colors: {},
    themes: {},
    rules: {},
    values: {},
    semantics: {},
    breakpoints: {},
    mediaQueries: {},
    keyframes: {},
    selectors: {},
    functions: {}
}

export default config
